/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

import Vue from 'vue'

// Notifications
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-default.css';
Vue.use(VueToast, {
    position: 'top',
    duration: 5000
});

window.axios.interceptors.response.use(
    response => {
        return response;
    },
    error => {
        if (error.response && error.response.data) {
            // Error in validation
            if (error.response.status == 422) {
                Vue.$toast.info('Encontramos um problema na validação do formulário :(');
            }

            // Error Common
            if (error.response.status == 406) {
                Vue.$toast.error(error.response.data);
            }
        }
        return Promise.reject(error);
    }
);

// Moment Js
const moment = require('moment')
require('moment/locale/pt')
Vue.use(require('vue-moment'), {
    moment
})

// Forms
import { HasError, AlertError } from 'vform'
Vue.component(HasError.name, HasError)
Vue.component(AlertError.name, AlertError)

// Loading
import VueContentLoading, {VclBulletList} from 'vue-content-loading'
Vue.component('vue-content-loading', VueContentLoading)
Vue.component('vcl-bullet-list', VclBulletList)

// Bs4 Vue
import { BootstrapVue } from 'bootstrap-vue'
Vue.use(BootstrapVue)

// Laravel Pagination
Vue.component('pagination', require('laravel-vue-pagination'));

// Multi Select
import Multiselect from 'vue-multiselect'
Vue.component('multiselect', Multiselect)

// Select
import vSelect from 'vue-select'
Vue.component('v-select', vSelect)

// Vue Filters
import Vue2Filters from 'vue2-filters'
Vue.use(Vue2Filters)

// Chart
import Raphael from 'raphael/raphael'
global.Raphael = Raphael

// Upload S3
window.S3Upload = require('./Shared/S3Upload');

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

Vue.component('logo', require('./Shared/Logo.vue').default);

Vue.component('notification', require('./Shared/Notification.vue').default);

// Layouts
Vue.component('main-content', require('./Shared/Layouts/MainContent.vue').default);

// Forms
Vue.component('text-input', require('./Shared/Forms/TextInput.vue').default);
Vue.component('file-input', require('./Shared/Forms/FileInput.vue').default);
Vue.component('checkbox-input', require('./Shared/Forms/CheckboxInput.vue').default);
Vue.component('loading-button', require('./Shared/Forms/LoadingButton.vue').default);
Vue.component('error-message', require('./Shared/Forms/ErrorMessage.vue').default);

// Players
Vue.component('status-player', require('./Pages/Players/StatusPlayer.vue').default);
Vue.component('synced-player', require('./Pages/Players/SyncedPlayer.vue').default);
Vue.component('events-player', require('./Pages/Players/EventsPlayer.vue').default);
Vue.component('live-view-player', require('./Pages/Players/LiveViewPlayer.vue').default);

// Campaigns
Vue.component('preview-news', require('./Pages/Campaigns/PreviewNews.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

// Inertia Js
import { InertiaApp } from '@inertiajs/inertia-vue'

Vue.mixin({ methods: { route: window.route } })
Vue.use(InertiaApp)

window.Vapor = require('laravel-vapor');

const app = document.getElementById('app')

new Vue({
    render: h => h(InertiaApp, {
        props: {
            initialPage: JSON.parse(app.dataset.page),
            resolveComponent: name => import(`@/Pages/${name}`).then(module => module.default),
        },
    }),
}).$mount(app)
